/** Same pattern as cleverence_rag/chz/etl/anonymize.py — Участник_XXXX */
export async function participantLabel(seed: string): Promise<string> {
  const data = new TextEncoder().encode(seed);
  const buf = await crypto.subtle.digest("SHA-256", data);
  const hex = Array.from(new Uint8Array(buf))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
  return `Участник_${hex.slice(0, 4).toUpperCase()}`;
}
